import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './coupon.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getCoupon = createSelector(selectProjectState, (state: State) => state.coupon);
